<template>
	<BaseInput
		name="AgeOfChildren"
		:label="`Child ${id + 1}`"
		type="Number"
		:min="0"
		:max="18"
		v-model="data.age"
		class="form-control form-control-lg dashInput"
		:required="true"
		rules="required"
		@valError="valError"
		@valSuccess="valSuccess"
	/>
</template>
<script>
	import { reactive, watch } from "vue";
	import BaseInput from "./BaseInput";

	export default {
		name: "ChildrenAge",
		props: {
			id: { type: Number, required: true, default: 0 },
		},
		components: {
			BaseInput,
		},
		emits: ["updateData"],
		setup: (props, { emit }) => {
			const data = reactive({
				age: 0,
			});

			watch(
				() => data.age,
				(preValue, newValue) => {
					emit("updateData", { age: parseInt(data.age, 10), id: props.id });
				},
			);

			const valError = (input) => {};
			const valSuccess = (input) => {};

			return {
				data,

				valError,
				valSuccess,
			};
		},
	};
</script>
